import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom';

import styled from 'styled-components';
import { AuthContext } from '../contexts/AuthContext';
import AppPage from '../layouts/AppPage';
import { DataContext, fetchAll } from '../contexts/DataContext';
import { useDevice } from '../contexts/DeviceContext';
import { get } from 'lodash';
import { metaTags } from '../lib/utils/metaTags';
import { DEFAULT_TITLE } from '../lib/settings';

const COLUMN_COUNT = 4;
const itemsToRows = (items) => {
  const columnLength = Math.ceil(items.length / COLUMN_COUNT);
  const rows = Array.from({ length: columnLength }, () => []);
  items.forEach((item, index) => {
    const rowIndex = Math.floor(index % columnLength);
    rows[rowIndex].push(item);
  });
  return rows;
};
const RATIO = 0.84;
const AUTHOR_LENGTH = `calc(100% / (${COLUMN_COUNT} + 0.5) * ${RATIO})`;
const AUTHOR_GAP = `calc(100% / (${COLUMN_COUNT} + 0.5) * ${1 - RATIO})`;

export default function Authors() {
  const { api } = useContext(AuthContext);
  const { authors, setAuthors } = useContext(DataContext);
  const  { isMobile } = useDevice();
  const baseUrl = window.location.origin;

  const getAuthors = useCallback(async () => {
    try {
      const authors = await fetchAll(api.getAuthors);
      authors.sort((a, b) => {
        const aKey = (a.surname || a.full_name).toLowerCase();
        const bKey = (b.surname || b.full_name).toLowerCase();
        return aKey.localeCompare(bKey)
      });
      setAuthors(authors);
    } catch (error) {
    };
  }, [api, setAuthors]);

  useEffect(() => {
    getAuthors();
  }, [api, getAuthors]);

  const MetaTags = useMemo(() => {
    return metaTags({
      title: `${DEFAULT_TITLE} | Автор:ки`,
      description: 'Автор:ки',
      image: '',
      url: 'https://chimeras.world/authors/',
    })
  }, []);

  return (
    <AppPage>
      {MetaTags}
      <AUTHORS>
        <h2>автор:ки</h2>
        <ul>
          { isMobile ? 
            (authors && authors.length > 0 && authors.map((author, index) => (
              <li key={index}>
                <Link className='link' to={`${baseUrl}/authors/${author.slug}`}>{author.full_name}</Link>
              </li>
            )))
              :
            (authors && authors.length > 0 && itemsToRows(authors).map((row, index) => (
              <div className='row' key={index}>
                {row.map((author, index) => (
                  <li key={index}>
                    <Link className='link' to={`${baseUrl}/authors/${author.slug}`}>{author.full_name}</Link>
                  </li>
                ))}
              </div>
            )))
          }
        </ul>
      </AUTHORS>
    </AppPage>
  )
}

const AUTHORS = styled.div`
  padding: 50px 20px 0 20px;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  font-family: var(--primary-font);

  & h2 {
    font-size: 1.125rem;
    font-weight: 700;
  }

  & ul {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    list-style: none;
  }

  & .link {
    font-size: 1rem;
    font-weight: 400;
    text-decoration: none;
    color: var(--black);
  }

  & .link:hover {
    text-decoration: underline;
  }

  @media (min-width: 768px) {
    margin-top: 4rem;
    padding: 0 var(--main-side-padding);

    & ul {
      display: flex;
      flex-direction: column;
    }

    & .row {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      gap: ${AUTHOR_GAP};
      margin-bottom: 0.625rem;
    }

    & li {
      min-width: ${AUTHOR_LENGTH};
    }

    & .row:nth-child(2n) {
      transform: translateX(calc((${AUTHOR_LENGTH} + ${AUTHOR_GAP}) / 2));
    }
  }
`;
